import React, { useState, useEffect, useRef } from 'react'
import './styles/Checkout.css'
import CloseIcon from '@mui/icons-material/Close';
import logo from '../assets/newro-green-logo.svg'
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Ticket from '../components/Ticket';
import { Calendar, MapPin, Clock } from 'lucide-react';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { Timestamp } from 'firebase/firestore';
import { startSignatureGenerate, PaymentForm } from '../payfast/Functions';
import { useAuth } from '../contexts/AuthContext';
import { addOrder } from '../api/OrdersAPI';
import { useModal } from '../contexts/ModalContext';
import { displayEventDate, displayEventTime } from '../utils/datetime';
import { Oval } from 'react-loader-spinner';
import { getEventById } from '../api/EventsAPI';
import { v4 as uuidv4 } from "uuid";

export default function Checkout({ handleClose, eventData, eventId }) {
  const { user } = useAuth();//TODO - check if user logged in else prompt to login
  const { openModal } = useModal();

  const [loading, setLoading] = useState(false);
  const [finalData, setfinalData] = useState({});//payfast data
  const [signed, setsigned] = useState(false);//payfast signature

  const [step, setstep] = useState(0); // 0: select tickets, 1: assign tickets, 2: confirm payment]
  const stepTitles = ["Please select your tickets", "Assign Tickets", "Please Confirm"]
  const [ticketOptions, setticketOptions] = useState([]);

  const [selectedTicketDetails, setselectedTicketDetails] = useState([]); //assigned attributes
  const [myselfTicketIndex, setmyselfTicketIndex] = useState(-1);

  const [ticketOrderGenerated, setticketOrderGenerated] = useState(false);
  const expiryTime = 300
  const [time, setTime] = useState(expiryTime);//ticket expiration

  const [reserveTicketsNum, setreserveTicketsNum] = useState(0);

  useEffect(() => {
    compileTicketOptions()
  }, []);

  useEffect(() => {
    if (step === 1 && !ticketOrderGenerated) {
      compileTicketDetails()
    }
  }, [step]);


  async function getNumberReservedTickets() { //update to latest
    const res = await getEventById(eventId)
    if (res.success) {
      const numReserved = res.eventData?.numReserved || 0
      setreserveTicketsNum(numReserved)
      return numReserved
    }
  }

  function compileTicketOptions() {//option from eventData (select)
    const compiledTicketOptions = []
    eventData.ticketOptions.forEach(option => {
      compiledTicketOptions.push({ ...option, amount: 0 })
    });
    setticketOptions(compiledTicketOptions)
    //set reserved amount
    const reservedAmount = eventData.numReserved || 0
    setreserveTicketsNum(reservedAmount)
  }

  function compileTicketDetails() {//ticketOptions with assigned attributes (assign)
    const compiledTicketDetails = []
    ticketOptions.forEach(option => {
      for (let index = 0; index < option.amount; index++) {
        compiledTicketDetails.push({ price: option.price, type: option.type, myself: false, email: "", firstName: "", lastName: "" })
      }
    });
    setselectedTicketDetails(compiledTicketDetails)
  }

  function assignTicketButtonPressed(index, forMyself) {
    if (forMyself) {
      setmyselfTicketIndex(index)
    } else {
      if (myselfTicketIndex === index) {
        setmyselfTicketIndex(-1)
      }
    }

  }

  function updateTicketDetails(e, index) { //input change event
    if (ticketOrderGenerated) setticketOrderGenerated(false)//order not valid (update with new details)
    let copyselectedTicketDetails = JSON.parse(JSON.stringify(selectedTicketDetails))
    switch (e.target.name) {
      case 'email':
        copyselectedTicketDetails[index] = { ...copyselectedTicketDetails[index], email: e.target.value }
        break;
      case 'fName':
        copyselectedTicketDetails[index] = { ...copyselectedTicketDetails[index], firstName: e.target.value }
        break;
      case 'lName':
        copyselectedTicketDetails[index] = { ...copyselectedTicketDetails[index], lastName: e.target.value }
        break;

      default:
        break;
    }
    setselectedTicketDetails(copyselectedTicketDetails)
  }



  async function generateOrder() {//generate "pending" order in firestore
    // console.log("Gen order")
    const amount = selectedTicketDetails.length//TODO limit amount
    if (!eventId || amount <= 0 || amount > 100) {
      throw new Error('Invalid input. Amount must be between 1 and 100.');
    }
    const expiresAt = Timestamp.fromDate(new Date(Date.now() + 6 * 60 * 1000)); // 5 minutes

    const orderTickets = []
    selectedTicketDetails.forEach((ticketValues, index) => {
      let orderTicketObj = {}

      const ticketId = eventId + uuidv4()
      if (myselfTicketIndex === index) {
        orderTicketObj = {
          ticketId: ticketId,
          firstName: user.displayName || "",
          lastName: '',
          email: user.email || "",
          type: ticketValues.type,
          forExistingUser: true
        }
      } else {
        orderTicketObj = {
          ticketId: ticketId,
          firstName: ticketValues.firstName,
          lastName: ticketValues.lastName,
          email: ticketValues.email,
          type: ticketValues.type,
          forExistingUser: false
        }
      }
      orderTickets.push({ ...orderTicketObj });
    });

    const userName = user.displayName || 'Legend'

    const orderProps = {
      userId: user.uid,
      userName,
      userEmail: user.email,
      eventId: eventId,
      eventTitle: eventData.title,
      eventDateTime: eventData.timestamp,
      orderTickets,
      status: 'pending',
      totalAmount: displayPriceTotal(),
      expiresAt, //if reached, dont create tickets and remove only order(saves writes)
    }
    const orderId = await addOrder(eventId, orderProps, amount)
    if (orderId) {
      return { orderId, success: true }
    }
    else {
      return { success: false, error: "Failed to create order" }
    }

  }

  function ticketButtonPressed(type, operation) {//buttons on tickets
    const copyTicketOptions = JSON.parse(JSON.stringify(ticketOptions))
    const index = copyTicketOptions.findIndex(option => option.type === type)
    const amountLeft = copyTicketOptions[index].numAvailable - reserveTicketsNum - copyTicketOptions[index].amount;
    if (operation === "+" && amountLeft > 0) {
      if (ticketOrderGenerated) setticketOrderGenerated(false)//order not valid (update with new details)
      copyTicketOptions[index].amount = copyTicketOptions[index].amount + 1
    } else if (operation === "-" && copyTicketOptions[index].amount > 0) {
      if (ticketOrderGenerated) setticketOrderGenerated(false)//order not valid (update with new details)
      copyTicketOptions[index].amount = copyTicketOptions[index].amount - 1
    }
    setticketOptions(copyTicketOptions)
  }

  const displayPriceTotal = () => {
    let total = 0
    ticketOptions.forEach(option => {
      total = total + option.price * option.amount
    });
    return total.toFixed(2)
  }

  const getAvailableTicketTotal = () => { //total number of tickets (all types)
    let total = 0
    ticketOptions.forEach(option => {
      total = total + option.numAvailable
    });
    return total
  }

  const getTicketTotal = () => { //total number of tickets (all types)
    let total = 0
    ticketOptions.forEach(option => {
      total = total + option.amount
    });
    return total
  }


  const timerRef = useRef(null); // To store the interval ID

  const startTimer = () => {
    clearInterval(timerRef.current);     // Stop existing timer if any
    setTime(expiryTime);                         // Reset time

    timerRef.current = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime === 0) {
          clearInterval(timerRef.current);
          openModal("alert", {
            alertProps: {
              type: 1,
              message: `Order expired, please try again`,
            },
          });
          handleClose()
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };


  async function stepPressed(stepNo) { //next or back
    if (stepNo === "next" && step < 2) {
      switch (step) {
        case 0: //moving to step 1
          const ticketAmount = getTicketTotal();
          if (ticketAmount > 0) {
            setstep(prev => prev + 1)
          } else {
            openModal("alert", {
              alertProps: {
                type: 1,
                message: `Please select at least one ticket to continue`,
              },
            });
          }
          break;
        case 1: //moving to step 2
          const results = ticketValidationPassed();
          if (results === true) {
            setLoading(true);
            try {

              // --check if tickets still available
              const latestReservedTicketsNum = await getNumberReservedTickets()
              const availableTotal = getAvailableTicketTotal()
              if ((latestReservedTicketsNum + selectedTicketDetails.length) > availableTotal) {
                openModal("alert", {
                  alertProps: {
                    type: 0,
                    message: `No more tickets available. We apologize for the inconvenience`,
                  },
                });
              } else {
                const res = await generateOrder();
                if (res.success) {
                  setticketOrderGenerated(true)
                  //GENERATE PAYFAST SIGNATURE
                  const buyerData = { userName: user.displayName, userId: user.uid, email: user.email }
                  const transactionDetails = { amount: displayPriceTotal(), orderId: res.orderId, itemName: "#" + res.orderId }
                  startSignatureGenerate(setfinalData, setsigned, buyerData, transactionDetails)
                }
                //start expired timer for order (reserved tickets)
                startTimer()
                // alert(res.message);
                setstep(prev => prev + 1)
              }
            } catch (err) {
              alert(err.message || 'Something went wrong');
            } finally {
              setLoading(false);
            }
          }
          break;
        case 2:
          break;


        default:
          break;
      }
    } else if (stepNo === "back" && step > 0) {
      clearInterval(timerRef.current);     // Stop existing timer if any
      setstep(prev => prev - 1)
    }
  }

  const ticketValidationPassed = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (let i = 0; i < selectedTicketDetails.length; i++) {
      const { firstName, lastName, email } = selectedTicketDetails[i];
      const ticketNumber = i + 1;
      if (i !== myselfTicketIndex) {
        if (!email || email.trim() === "") {
          openModal("alert", {
            alertProps: {
              type: 0,
              message: `Please enter an email for ticket ${ticketNumber}`,
            },
          });
          return false;
        }

        if (!emailRegex.test(email)) {
          openModal("alert", {
            alertProps: {
              type: 0,
              message: `Please enter a valid email for ticket ${ticketNumber}`,
            },
          });
          return false;
        }

        if (!firstName || firstName.trim() === "") {
          openModal("alert", {
            alertProps: {
              type: 0,
              message: `Please enter a first name for ticket ${ticketNumber}`,
            },
          });
          return false;
        }

        if (!lastName || lastName.trim() === "") {
          openModal("alert", {
            alertProps: {
              type: 0,
              message: `Please enter a last name for ticket ${ticketNumber}`,
            },
          });
          return false;
        }
      }

    }

    return true;
  };



  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <div className='step-body-container'>
            <div className='tickets-container'>
              {ticketOptions?.map((ticket, index) => {
                return (
                  <Ticket
                    key={index}
                    reserveTicketsNum={reserveTicketsNum}
                    data={ticket}
                    ticketButtonPressed={ticketButtonPressed} />
                )
              })}
            </div>
          </div>
        )
        break;
      case 1:
        return (
          <div className='step-body-container assign-container' >
            {selectedTicketDetails.map((ticket, index) => {
              return (
                <div key={index} className='ticket-assign-container'>
                  <div className='ticket-assign-container-top'>
                    <div className='ticket-type-title'>
                      <p>
                        {ticket.type + ' - ' + (index + 1)}
                      </p>
                    </div>
                    <div className='ticket-assignment-container'>
                      <p>
                        Ticket for:
                      </p>
                      <div className='ticket-assignment-buttons'>
                        <button className='assign-ticket-button' onClick={() => assignTicketButtonPressed(index, true)}
                          style={{
                            backgroundColor: myselfTicketIndex === index ? "white" : 'transparent',
                            color: myselfTicketIndex === index ? "var(--color-primary)" : 'white'
                          }}>Myself</button>
                        <button className='assign-ticket-button' onClick={() => assignTicketButtonPressed(index, false)}
                          style={{
                            backgroundColor: myselfTicketIndex === index ? "transparent" : 'white',
                            color: myselfTicketIndex === index ? "white" : 'var(--color-primary)'
                          }}>A Friend</button>
                      </div>
                    </div>
                  </div>
                  {myselfTicketIndex !== index &&
                    <div className='ticket-assign-container-body'>
                      <input onChange={(e) => updateTicketDetails(e, index)} value={ticket.email} name='email' className='assign-friend-input' placeholder='Email'></input>
                      <input onChange={(e) => updateTicketDetails(e, index)} value={ticket.firstName} name='fName' className='assign-friend-input' placeholder='First Name'></input>
                      <input onChange={(e) => updateTicketDetails(e, index)} value={ticket.lastName} name='lName' className='assign-friend-input' placeholder='Last Name'></input>
                    </div>
                  }
                </div>)
            })}
          </div>
        )
        break;

      case 2:
        const testingMode = false;
        const pfHost = testingMode ? "sandbox.payfast.co.za" : "www.payfast.co.za";
        return (
          <div className='confirm-container'>
            <div className='event-details'>
              <div className='title'>Event Details</div>
              <div className='details-container'>
                <div className='event-detail-item'>
                  <Calendar size={20} />
                  <p style={{ margin: 0 }}>{displayEventDate(eventData)}</p>
                </div>
                <div className='event-detail-item'>
                  <MapPin size={20} />
                  <p style={{ margin: 0 }}>{eventData.location.name}</p>
                </div>
                <div className='event-detail-item'>
                  <Clock size={20} />
                  <p style={{ margin: 0 }}>{displayEventTime(eventData)}</p>
                </div>
              </div>
            </div>
            <div className='order-details'>
              <div className='title'>
                <h1>Your Order Details</h1>
                {/* <p className='id'>Order ID: 123456</p> */}
                <p className='id'>{'Total tickets: ' + getTicketTotal()}</p>
              </div>
              {selectedTicketDetails.map((ticket, index) => (
                <div key={index} className='ticket-summary-container'>
                  <div className='ticket-summary'>
                    <div className='ticket-counter'>{index + 1}</div>
                    <div className='ticket-summary-text'>
                      <h2 style={{ fontSize: '16px', margin: 0 }}>{ticket.firstName + " " + ticket.lastName}</h2>
                      <p style={{ fontSize: '14px', margin: 0 }}>{ticket.type}</p>
                    </div>
                  </div>
                  <div style={{ fontSize: '16px', margin: 0, fontWeight: '800' }}>R{ticket.price}</div>
                </div>
              ))}

            </div>
            <div className='total-container'>
              {/* <div className='subtotal'>
                <p>Subtotal</p>
                <p>R300</p>
              </div> */}
              <div className='total'>
                <p>Total</p>
                <p>{"R" + displayPriceTotal()}</p>
              </div>
            </div>
            <div className='pay-now-container' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              {signed ?
                <PaymentForm pfHost={pfHost} finalData={finalData} />
                :
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Oval
                    visible={true}
                    height="24"
                    width="24"
                    color="#ffffff"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={6}
                  />
                </div>
              }
            </div>

          </div>
        )
        break;

      default:
        break;
    }
  }


  return (
    <div className='backdrop' onClick={handleClose}>
      <div className='checkout-modal-body' onClick={(e) => e.stopPropagation()} >

        <div className='title-container'>
          <div className='header-container'>
            <div className="logo">
              <img src={logo} alt='logo' className="logo-image" />
              <h1>newro</h1>
            </div>
            <h2>{eventData.title}</h2>
          </div>
          <button className='close-button' onClick={handleClose}>
            <CloseIcon sx={{ color: 'var(--color-primary)', fontSize: '30px' }} />
          </button>
        </div>

        <div className='checkout-body-container'>
          <div className='step-total-container'>
            <h2>{stepTitles[step]}
              {/* 
                Possible Addition: Add a color that changes from green to red when it reaches 2min
                This will be used to indicate that the order is about to expire, and the user should hurry up
              */}
              {step === 2 && (
                <span style={{
                  border: time < 100 ? '1px solid red' : '1px solid gray', borderRadius: '20px',
                  padding: '3px 10px', fontSize: '15px', color: time < 100 ? 'red' : 'gray', marginLeft: '10px'
                }}>

                  {`${Math.floor(time / 60)}`.padStart(2, 0)}:
                  {`${time % 60}`.padStart(2, 0)}

                </span>
              )}
            </h2>

            <h2 className='total-value'>{"Total: R " + displayPriceTotal()}</h2>
          </div>

          {renderStep()}

          <div className='bottom-container'>
            <div className='checkout-progress-container'>
              <div className='checkout-progress-checkpoint'
                style={{
                  color: step >= 0 ? 'white' : 'var(--color-primary)',
                  backgroundColor: step >= 0 ? 'var(--color-primary)' : 'white'
                }}>
                {step > 0 ? <DoneAllIcon /> : '1'}
              </div>
              <hr className='progress-line'></hr>
              <div className='checkout-progress-checkpoint'
                style={{
                  color: step >= 1 ? 'white' : 'var(--color-primary)',
                  backgroundColor: step >= 1 ? 'var(--color-primary)' : 'white'
                }}>
                {step > 1 ? <DoneAllIcon /> : '2'}
              </div>
              <hr className='progress-line'></hr>
              <div className='checkout-progress-checkpoint'
                style={{
                  color: step >= 2 ? 'white' : 'var(--color-primary)',
                  backgroundColor: step >= 2 ? 'var(--color-primary)' : 'white'
                }}>
                {step > 2 ? <DoneAllIcon /> : '3'}
              </div>
            </div>
            <div className='button-container'>
              <button onClick={() => stepPressed("back")} className='secondary-button'>Back</button>
              {step < 2 &&
                <button onClick={() => stepPressed("next")} className='button' >
                  {loading ? (
                    <Oval
                      visible={true}
                      height="24"
                      width="24"
                      color="#ffffff"
                      ariaLabel="oval-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      strokeWidth={6}
                    />
                  ) : (
                    "Next"
                  )}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
